import React from "react";
import SubmittedCopyright from "../sumitted_copyright/SubmittedCopyright";

const ReconsiderationApprovalCopyright = () => {
  const fileStatus = 33;
  const applicationPath = {
    copyright: "/admin/reconsideration-approval-copyright",
    agreement: "/admin/reconsideration-approval-agreement",
  };
  return (
    <SubmittedCopyright
      pageTitle={"অনুমোদন পুনর্বিবেচনা"}
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={"/admin/reconsideration-copyright-details"}
    />
  );
};

export default ReconsiderationApprovalCopyright;
